var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.questionYoutubeLink)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }